// Background-image upload limits, kept in sync with the server rule in
// app/models/image.rb (ALLOWED_CONTENT_TYPES and MAX_FILE_SIZE). The file picker
// offers only the formats the server accepts, so a user does not pick a PDF or
// other file that the server then rejects.
export const IMAGE_ACCEPT = 'image/jpeg,image/png,image/gif,image/webp';
export const IMAGE_FORMATS_HINT = 'JPEG, PNG, GIF or WebP, up to 10 MB.';

// Single owner of the planner background-image upload event, so both planners
// report the same name and property keys. result is 'success', 'rejected' (the
// server refused the file) or 'error' (the request failed).
export function capturePlannerImageUpload({ plannerVersion, result, fileType, fileSizeBytes, status = null }) {
  window.posthog?.capture('planner_image_uploaded', {
    result,
    planner_version: plannerVersion,
    file_type: fileType || null,
    file_size_bytes: fileSizeBytes ?? null,
    status,
  });
}
